<nwm-menu />
<div class="content">
  @if (hasClientList && isCollapse) {
    <button aria-label="Expand Sidebar" class="expand-btn d-print-none" (click)="isCollapse = false"><i class="fa fa-angle-right"></i></button>
  }
  <div class="main">
    <div class="row" [ngClass]="{'ml-3': hasClientList && isCollapse}">
      <div class="col-xxl-10 offset-xxl-1">
        <div class="row">
          @if (hasClientList) {
            <div class="clientMenu side-menu d-print-none" [ngClass]="{'col-lg-3': !isCollapse ,'d-none': isCollapse}">
              <button aria-label="Collapse Sidebar" class="collapse-btn" (click)="isCollapse = true"><i class="fa fa-angle-left"></i></button>
              <div class="clientMenu-content pt-lg-4">
                <side-menu
                  #clientSideMenu
                  class="full-height no-indent dont-indent-sticky-header"
                  menuTitle="Search By Client Name"
                  [defaultTitle]="filterText===noClientTag ? 'Other Client Documents': 'Search By Client Name'"
                  [items]="accountantClients"
                  [active]="filterText"
                  (menuChange)="changeClient($event)">
                  <div class="h3-text d-none d-lg-block">Search By Client Name</div>
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="flexSwitchCheckDefault" [(ngModel)]="newDocsOnly" (change)="newDocsOnlyChange()">
                    <label class="custom-control-label" for="flexSwitchCheckDefault">New Documents Only</label>
                  </div>
                  <hr>
                    <div tabindex="0" class="clientMenu-link" (click)="changeClient('') && clientSideMenu.closeMenu()" [ngClass]="{'active':filterText===''}">All Clients</div>
                    <div tabindex="0" class="clientMenu-link" (click)="changeClient(noClientTag) && clientSideMenu.closeMenu()" [ngClass]="{'active':filterText===noClientTag}">Other Client Documents
                      @if (otherClientsHasNew) {
                        <div class="new"></div>
                      }
                      <i>Files without an exact match to a client appear here</i>
                    </div>
                    <hr>
                    </side-menu>
                  </div>
                </div>
              }

              <div class="w-print-100 mb-5 mt-4" [ngClass]="{'col-lg-9 offset-lg-3': !isCollapse && hasClientList,'col-lg-12': isCollapse || !hasClientList}" >

                <div class="row my-4">
                  <div class="col-sm-4"><h1>Documents</h1></div>
                  <div class="col-sm-8 text-right">
                    @if (user!.isAccountant) {
                      <button class="btn-secondary sml-btn mr-3" (click)="openContactUsModal(contactUsModal)">Contact Us</button>
                    }
                    @if (user!.isAccountant || auth.hasAccess('Upload_Documents')) {
                      <button class="btn-primary sml-btn" (click)="openModalToUploadDocuments(contactUsModal)">Upload Documents</button>
                    }</div>
                  </div>
                  <div class="row">
                    @if (!user?.isAccountant && documentsLoaded) {
                      <side-menu
                        class="side-menu no-indent d-lg-none"
                        [ngClass]="{'offset4ClientList':hasClientList}"
                        menuTitle="Documents Category"
                        [items]="categories"
                        [active]="selectedDocumentType"
                        (menuChange)="selectDocType($event)" />
                    }

                    <div class="col-lg-7 mt-3 mt-lg-0 filters-bar">
                      <div class="dates mt-lg-3">
                        <div class="input-group">
                          <label class="date-label mr-2 mb-3" for="d1"><b>From</b></label>
                          <div class="date-selector mb-3">
                            <input class="form-control" [placeholder]="displayStartDate" name="d1" [(ngModel)]="startDateModel" ngbDatepicker #d1="ngbDatepicker" (ngModelChange)="dateChange()"
                              id="d1" placement="bottom-left" [footerTemplate]="startDateFooter" [minDate]='minDate' [maxDate]='maxDate' datepicker-options="{startingDay:0}">
                              <button class="button-without-border fa fa-calendar" aria-label="Open Date Selector" (click)="d1.toggle()"></button>
                            </div>
                            <label class="date-label mx-3 mb-3" for="d2"><b>To</b></label>
                            <div class="date-selector mb-3">
                              <input id="d2" class="form-control" [placeholder]="displayEndDate" name="d2" [(ngModel)]="endDateModel" ngbDatepicker #d2="ngbDatepicker" (ngModelChange)="dateChange()"
                                placement="bottom-right" [footerTemplate]="endDateFooter" [minDate]='minDate' [maxDate]='maxDate'>
                                <button class="button-without-border fa fa-calendar" aria-label="Open Date Selector" (click)="d2.toggle()"></button>
                              </div>
                              <button class="btn-secondary ml-3 mb-3" [disabled]="disableResetDateButton" (click)="resetDates()" style="height:38px;line-height:38px">
                                <span>Reset Range</span>
                                <i class="fa fa-repeat ml-2"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-5 mt-3 mt-lg-0 mb-2 filters-bar">
                          <input type="text" name="keyword" id="keyword" value="" placeholder="Filter by Keyword or Client Name" [(ngModel)]="filterText" (keyup.enter)="filterDocuments()" class="form-control my-lg-3">
                          <i aria-label="Search/Remove Search" role="button" tabindex="0" class="search-icon fa my-lg-3" [ngClass]="curentFilterText === '' || curentFilterText !== filterText? 'fa-search' : 'fa-close'" (click)="(curentFilterText === '' || curentFilterText !== filterText) ? filterDocuments() : clearTextFilter()"></i>
                        </div>

                        <div class="mt-4 col-12">
                          <ul class="NWMtabs" [ngClass]="{'d-none d-lg-flex':!user?.isAccountant}">
                            @for (c of categories; track c) {
                              <li [ngClass]="{'active':c.id === selectedDocumentType, 'hasNew':c.hasNew}"><a (click)="selectDocType(c.id!);" tabindex="-1" class="tab">{{c.title}}</a></li>
                            }
                          </ul>

                          <div class="scrollable-wrap">
                            <div class="scrollable">
                              <div class="scrollable-button left"></div>
                              <div class="scrollable-button"></div>
                              <table width="100%" class="NWMtable sticky_header docTable table table-striped mb-0">
                                <thead>
                                  <tr>
                                    <td width="40">
                                      <input aria-label="Select/Unselect all" type="checkbox" [(ngModel)]="allChecked">
                                    </td>
                                    <td (click)="toggleSort('FileName')" class="sortable">
                                      <span>File Name</span>
                                      <i class="fa ml-2" [ngClass]="sortField === 'FileName' ? (sortDir<0 ? 'fa-sort-asc' : 'fa-sort-desc') : ''" aria-hidden="true"></i>
                                    </td>
                                    <td width="140" role="button" class="text-left sortable" (click)="toggleSort('DatePostedFull')" style="white-space:nowrap">
                                      <span>Date Posted</span>
                                      <i class="fa ml-2" [ngClass]="sortField === 'DatePostedFull' ? (sortDir<0 ? 'fa-sort-asc' : 'fa-sort-desc') : ''" aria-hidden="true"></i>
                                    </td>
                                    <td width="160" role="button" class="d-none d-sm-table-cell text-left sortable" (click)="toggleSort('FileViewTime')" style="white-space:nowrap">
                                      <span>Date Downloaded</span>
                                      <i class="fa ml-2" [ngClass]="sortField === 'FileViewTime' ? (sortDir<0 ? 'fa-sort-asc' : 'fa-sort-desc') : ''" aria-hidden="true"></i>
                                    </td>
                                    <td width="122" class="d-none d-sm-table-cell text-right"></td>
                                  </tr>
                                </thead>
                                <tbody>
                                  @if (pagedDocuments) {
                                    <ng-container *ngTemplateOutlet="docsList" />
                                  }
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="float-left form-inline pt-4">
                            <div class="form-group mr-2">
                              <button title="Use the checkboxes above to select multiple files to download" [disabled]="!selectedCount" class="btn-secondary" (click)="downloadSelected()">Download Selected ({{ selectedCount }})</button>
                            </div>
                          </div>

                          <div class="form-inline float-right mb-4">
                            <div class="form-group pt-4">
                              <label for="pageSize" class="font-weight-bold">Rows Displayed</label>
                              <select [(ngModel)]="pageSize" name="pageSize" class="form-control mx-sm-3" id="pageSize" (ngModelChange)="filterDocuments()">
                                <option  [value]="0" [selected]="!pageSize">All</option>
                                @for (o of pageOptions; track o) {
                                  <option [value]="o" [selected]="pageSize  === o">{{o}}</option>
                                }
                              </select>
                            </div>
                            <span class="mr-3 pt-4">Displaying {{ pageItemRange }} of {{ filteredDocuments.length }} Results</span>
                            @if (totalPages > 1) {
                              <ngb-pagination [collectionSize]="filteredDocuments.length"
                                [(page)]="page" [maxSize]="2" (pageChange)="setPage()"
                                class="pagination pt-4"
                                [pageSize]="pageSize"
                                [boundaryLinks]="true">
                                <ng-template ngbPaginationFirst>First</ng-template>
                                <ng-template ngbPaginationPrevious>Previous</ng-template>
                                <ng-template ngbPaginationNext>Next</ng-template>
                                <ng-template ngbPaginationLast>Last</ng-template>
                              </ngb-pagination>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ng-template #docsList>
            @if (pagedDocuments) {
              @for (doc of pagedDocuments; track doc) {
                <tr
                  (click)="previewFile($event, doc)">
                  <td class="checkbox-cell align-middle" click-stop-propagation>
                    <input aria-label="Select/Unselect" type="checkbox" [(ngModel)]="doc.IsChecked" (change)="verifyAllChecked()">
                  </td>
                  <td class="text-left align-middle" style="white-space:nowrap">
                    <span class="d-inline-block text-truncate align-middle" [title]="doc.FileName">{{doc.FileName}}</span>
                    @if (doc.IsNew) {
                      <div class="new"></div>
                    }
                  </td>
                  <td class="text-left align-middle">
                    {{doc.DatePostedFull | date:'MMM d, yyyy' | uppercase}}
                  </td>
                  <td class="d-none d-sm-table-cell text-left align-middle">
                    {{doc.FileViewTime | date:'MMM d, yyyy' | uppercase}}
                  </td>
                  <td class="d-none d-sm-table-cell pr-1 action-links text-right">
                    <a class="px-3 py-2" (click)="downloadFiles([doc])" click-stop-propagation tabindex="-1">Download</a>
                  </td>
                </tr>
              }
            }
          </ng-template>

          <ng-template #startDateFooter>
            <hr class="my-0">
            <div class="mx-auto text-center">
              <button class="btn btn-NWM btn-sm m-2" (click)="startDateModel = today; d1.close(); dateChange();">Today</button>
            </div>
          </ng-template>

          <ng-template #endDateFooter>
            <hr class="my-0">
            <div class="mx-auto text-center">
              <button class="btn btn-NWM btn-sm m-2" (click)="endDateModel = today; d2.close(); dateChange();">Today</button>
            </div>
          </ng-template>

          <ng-template #contactUsModal let-modal>
            <nwm-advisor-contact [formAction]="modalAction" [formTitle]="modalTitle" (formCancelled)="modal.close()" (formSubmitted)="documentUploaded()" />
          </ng-template>
